/*
	The header's behaviour: the category rail, the account panel, the mobile menu and the search
	suggestion box. It was 13 KB of inline <script> in sections/header.liquid, which a browser must
	parse and run before it carries on with the document — and on the home page that sits in front of
	the hero image, the phone's Largest Contentful Paint element. Measured on the live store, the
	image itself downloads in about 20ms but is not even requested for 1.5 seconds, because 122 KB of
	parser-blocking script runs first. (82 KB of that is Shopify's own web-pixels loader, which a
	theme cannot move; this file is the part that can.)

	Deferred, so it runs after the document is parsed and before DOMContentLoaded. Everything here is
	either a function called from an onclick attribute — which only needs to exist by the time
	somebody clicks — or a listener that waits for DOMContentLoaded anyway.
*/
	// Toggle Sidebar functions
	// The account panel is a modal, so it has to behave like one: focus moves in when it opens, Escape and
	// the overlay close it, Tab cycles inside it instead of walking out behind the backdrop, and while it is
	// closed `inert` keeps its three controls out of the tab order and the accessibility tree. Without that
	// last part, tabbing any page of the store eventually landed focus on an invisible off-screen x.
	var accountSidebarReturnFocus = null;

	function accountSidebarKeydown(event) {
		if (event.key === 'Escape' || event.key === 'Esc') {
			event.preventDefault();
			closeSidebar();
			return;
		}
		if (event.key !== 'Tab') return;

		var panel = document.getElementById('accountSidebar');
		var items = panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
		if (!items.length) return;

		var first = items[0];
		var last = items[items.length - 1];
		var outside = !panel.contains(document.activeElement);

		if (event.shiftKey && (outside || document.activeElement === first)) {
			event.preventDefault();
			last.focus();
		} else if (!event.shiftKey && (outside || document.activeElement === last)) {
			event.preventDefault();
			first.focus();
		}
	}

	function openSidebar() {
		var panel = document.getElementById('accountSidebar');
		accountSidebarReturnFocus = document.activeElement;
		panel.removeAttribute('inert');
		panel.setAttribute('aria-hidden', 'false');
		panel.classList.remove('translate-x-full');
		document.getElementById('accountOverlay').classList.remove('hidden');
		document.body.style.overflow = 'hidden';
		document.addEventListener('keydown', accountSidebarKeydown);
		// Focus the panel itself, not the close button: a programmatically focused <button> can match
		// :focus-visible and paint a ring for mouse users, and this way the dialog's title is announced first.
		panel.focus({ preventScroll: true });
	}

	function closeSidebar() {
		var panel = document.getElementById('accountSidebar');
		document.removeEventListener('keydown', accountSidebarKeydown);
		panel.classList.add('translate-x-full');
		document.getElementById('accountOverlay').classList.add('hidden');
		document.body.style.overflow = '';

		// Move focus out before setting inert, or the browser blurs to <body> instead.
		var back = accountSidebarReturnFocus;
		accountSidebarReturnFocus = null;
		if (back && back.isConnected && typeof back.focus === 'function' && !panel.contains(back)) {
			back.focus({ preventScroll: true });
		}
		panel.setAttribute('aria-hidden', 'true');
		panel.setAttribute('inert', '');
	}

	function togglePassword() {
		var passwordField = document.getElementById('AccountPanel-Password');
		var icon = document.querySelector('.toggle-password');
		if (passwordField.type === 'password') {
			passwordField.type = 'text';
			icon.classList.remove('fa-eye');
			icon.classList.add('fa-eye-slash');
		} else {
			passwordField.type = 'password';
			icon.classList.remove('fa-eye-slash');
			icon.classList.add('fa-eye');
		}
	}

	// Mobile menu functions
	function toggleSidebar() {
		const sidebar = document.getElementById('mobile-nav-sidebar');
		const overlay = document.getElementById('mobile-nav-overlay');
		sidebar.classList.toggle('open');
		overlay.classList.toggle('active');
		document.body.style.overflow = sidebar.classList.contains('open') ? 'hidden' : '';
	}

	function toggleDropdown(element) {
		const submenu = element.nextElementSibling;
		const arrow = element.querySelector('.mobile-nav-arrow');
		if (submenu && submenu.classList.contains('mobile-nav-submenu')) {
			submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
			arrow.classList.toggle('mobile-nav-rotate');
		}
	}

	function showMenu() {
		document.getElementById('mobile-nav-category-list').style.display = 'none';
		document.getElementById('mobile-nav-menu-list').style.display = 'block';
		document.querySelectorAll('.mobile-nav-tab').forEach((tab) => {
			tab.classList.remove('active');
			tab.classList.add('inactive');
		});
		document.querySelectorAll('.mobile-nav-tab')[1].classList.remove('inactive');
		document.querySelectorAll('.mobile-nav-tab')[1].classList.add('active');
	}

	function showCategories() {
		document.getElementById('mobile-nav-category-list').style.display = 'block';
		document.getElementById('mobile-nav-menu-list').style.display = 'none';
		document.querySelectorAll('.mobile-nav-tab').forEach((tab) => {
			tab.classList.remove('active');
			tab.classList.add('inactive');
		});
		document.querySelectorAll('.mobile-nav-tab')[0].classList.remove('inactive');
		document.querySelectorAll('.mobile-nav-tab')[0].classList.add('active');
	}

	/* Search suggestions, for the desktop bar and the phone / tablet one.
	   - three across, three down, and nothing but photo, name and price
	   - the sale price with the old one struck through, as on the product cards
	   - the last row IS the "View all results" link, edge to edge
	   - suggest.json answers first; when it comes back with fewer than nine the grid is
	     topped up from the results page's own index (templates/search.suggest.liquid)
	   - type a product's exact name and, after 3 seconds of no more typing, its page opens:
	     the pause is what lets "Infinix Note 40 Pro" be typed past "Infinix Note 40". */
	document.addEventListener('DOMContentLoaded', function () {
		var EXACT_MATCH_DELAY = 3000;
		var LIMIT = 9;
		var searchUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

		var boxes = [
			{ input: document.getElementById('search-bar'), panel: document.getElementById('search-results') },
			{ input: document.getElementById('mobile-search-bar'), panel: document.getElementById('mobile-search-results') },
		].filter(function (box) {
			return box.input && box.panel;
		});

		if (!boxes.length) return;

		function money(amount) {
			var value = Number(amount);
			if (!isFinite(value)) return '';
			return 'Rs.' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		}

		function resultsUrl(query) {
			return searchUrl + 'search?q=' + encodeURIComponent(query) + '&type=product';
		}

		function normalise(text) {
			return String(text || '')
				.toLowerCase()
				.replace(/\s+/g, ' ')
				.trim();
		}

		boxes.forEach(function (box) {
			var grid = box.panel.querySelector('[data-suggest-grid]');
			var viewAll = box.panel.querySelector('[data-suggest-all]');
			var placeholder = box.panel.getAttribute('data-placeholder') || '';
			var debounce;
			var exactTimer;
			var controller;

			function hide() {
				box.panel.classList.add('hidden');
				window.clearTimeout(exactTimer);
			}

			function show() {
				box.panel.classList.remove('hidden');
			}

			// Nothing matches what is typed: take the previous query's cards down with the panel, so
			// they cannot be clicked, and cannot come back on the next focus.
			function clear() {
				grid.textContent = '';
				hide();
			}

			function card(product) {
				var link = document.createElement('a');
				link.className = 'be-suggest__item';
				link.href = product.url;

				var media = document.createElement('span');
				media.className = 'be-suggest__media';
				var image = document.createElement('img');
				image.loading = 'lazy';
				image.alt = '';
				image.src = product.image || (product.featured_image && product.featured_image.url) || placeholder;
				image.onerror = function () {
					image.onerror = null; // one fallback only: re-assigning a src that also fails reloads forever
					if (placeholder) image.src = placeholder;
				};
				media.appendChild(image);

				var text = document.createElement('span');
				text.className = 'be-suggest__text';
				var title = document.createElement('span');
				title.className = 'be-suggest__title';
				title.textContent = product.title;

				var price = document.createElement('span');
				price.className = 'be-suggest__price';
				var now = document.createElement('span');
				now.className = 'be-suggest__now';
				now.textContent = money(product.price);
				price.appendChild(now);

				// compare_at_price_min is 0 (or the same as the price) when nothing is on sale
				var was = Number(product.compare_at_price_min || 0);
				if (was > Number(product.price)) {
					var old = document.createElement('s');
					old.className = 'be-suggest__was';
					old.textContent = money(was);
					price.appendChild(old);
				}

				text.appendChild(title);
				text.appendChild(price);
				link.appendChild(media);
				link.appendChild(text);
				return link;
			}

			// `drawn` is how many of these cards the grid already shows: the top-up only ever adds
			// to the list, so the cards that are already up never flicker away and back.
			function render(products, query, drawn) {
				if (!drawn) grid.textContent = '';
				products.slice(drawn || 0).forEach(function (product) {
					grid.appendChild(card(product));
				});
				viewAll.href = resultsUrl(query);
				viewAll.textContent = 'View all results for “' + query + '”';
				show();
			}

			// The whole name typed out: open that product, but only after a pause long enough to
			// type a longer name that starts with it.
			function watchForExactMatch(products, query) {
				window.clearTimeout(exactTimer);
				var match = products.filter(function (product) {
					return normalise(product.title) === normalise(query);
				})[0];
				if (!match) return;

				exactTimer = window.setTimeout(function () {
					if (normalise(box.input.value) !== normalise(query)) return;
					window.location.href = match.url;
				}, EXACT_MATCH_DELAY);
			}

			// The last word on a query: draw it and start the exact-name countdown.
			function settle(products, query, drawn) {
				if (normalise(box.input.value) !== normalise(query)) return; // a newer query won
				if (!products.length) {
					clear();
					return;
				}
				render(products, query, drawn);
				watchForExactMatch(products, query);
			}

			// suggest.json's order first, then whatever the search index adds, nine at most
			function mergeByHandle(products, extra) {
				var merged = products.slice(0, LIMIT);
				var keys = merged.map(function (product) {
					return product.handle || product.url;
				});
				extra.forEach(function (product) {
					var key = product.handle || product.url;
					if (merged.length >= LIMIT || keys.indexOf(key) !== -1) return;
					keys.push(key);
					merged.push(product);
				});
				return merged;
			}

			// A safety net for a half-empty grid: if predictive search ever hands back fewer
			// products than the results page finds, fill the rest from the results page's own index
			// (templates/search.suggest.liquid). Only a short answer that drew at least one card
			// pays for this request — an empty answer has nothing to top up.
			function topUp(products, query, signal) {
				fetch(resultsUrl(query) + '&view=suggest', signal ? { signal: signal } : undefined)
					.then(function (response) {
						return response.ok ? response.json() : null;
					})
					.then(function (data) {
						settle(mergeByHandle(products, (data && data.products) || []), query, products.length);
					})
					.catch(function (error) {
						if (error && error.name === 'AbortError') return;
						settle(products, query, products.length); // the short answer stands on its own
					});
			}

			function search(query) {
				if (controller) controller.abort();
				controller = typeof AbortController === 'function' ? new AbortController() : null;
				var signal = controller ? controller.signal : null;

				var url =
					searchUrl +
					'search/suggest.json?q=' +
					encodeURIComponent(query) +
					'&resources[type]=product&resources[limit]=' +
					LIMIT;

				fetch(url, signal ? { signal: signal } : undefined)
					.then(function (response) {
						return response.json();
					})
					.then(function (data) {
						var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
						if (normalise(box.input.value) !== normalise(query)) return; // a newer query won
						if (products.length >= LIMIT) {
							settle(products, query);
							return;
						}
						// Nothing to top up onto, and no card to keep: the stale grid would otherwise
						// stay clickable for the whole top-up round-trip (~550 ms measured).
						if (!products.length) {
							clear();
							return;
						}
						render(products, query); // the fast answer, up while the top-up travels
						topUp(products, query, signal);
					})
					.catch(function (error) {
						if (error && error.name === 'AbortError') return;
						clear();
					});
			}

			box.input.addEventListener('input', function () {
				window.clearTimeout(debounce);
				window.clearTimeout(exactTimer);
				var query = box.input.value.trim();
				if (query.length < 2) {
					hide();
					return;
				}
				debounce = window.setTimeout(function () {
					search(query);
				}, 250);
			});

			box.input.addEventListener('focus', function () {
				if (grid.children.length && box.input.value.trim().length >= 2) show();
			});

			box.input.addEventListener('keydown', function (event) {
				if (event.key === 'Escape') hide();
			});

			document.addEventListener('click', function (event) {
				if (!box.panel.contains(event.target) && !box.input.contains(event.target)) hide();
			});
		});
	});
